// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import * as z from 'zod';
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { noteSchema } from '@/note/api/types';

const getProjectNotesResponseSchema = z.object({
  data: z.array(noteSchema),
  metadata: responseMetadataSchema,
});

type GetProjectNotesResponse = z.infer<typeof getProjectNotesResponseSchema>;

/**
 * Get notes for a project
 * @param projectKey The key of the project
 * @returns A promise that resolves to the notes response
 */
export async function getProjectNotes(
  projectKey: string
): Promise<GetProjectNotesResponse> {
  const url = `/v1/project/${projectKey}/note`;
  const response = await api.get(url);

  return parseResponse(getProjectNotesResponseSchema, response.data, {
    schemaName: 'ProjectNotes',
    endpoint: url,
  });
}
